import type { IconData } from '@stacksjs/iconify-core'

export const computersDevicesElectronicsTablet: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4.565 0v1.53h-1.52v28.95h1.52V32h22.86v-1.52h1.53V1.53h-1.53V0Zm12.19 30.48h-1.52v-1.52h1.52Zm9.15-3.05H6.1V3.05h19.81Z\"/><path fill=\"currentColor\" d=\"M15.235 12.19h1.52v3.05h7.62V7.62h-7.62v3.05h-1.52V7.62h-7.62v7.62h7.62Zm3.05-3.04h4.57v4.57h-4.57Zm-4.57 4.57h-4.57V9.15h4.57Z\"/><path fill=\"currentColor\" d=\"M19.805 10.67h1.53v1.52h-1.53Zm-1.52 6.09h1.52v1.53h-1.52Zm-3.05 1.53h3.05v1.52h-3.05Zm-4.57-7.62h1.52v1.52h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computersDevicesElectronicsTablet
